import qs from 'qs';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getCCPUrl, buildUrl } from 'utils';
import { reportsActions } from 'state/modules/reports';
import Loading from 'components/Loading';

const ReportDownload = () => {
  const dispatch = useDispatch();
  const { downloadUrl, downloadError } = useSelector((state) => state.reports);
  const { user, isAuthenticated, fetchingUser } = useSelector((state) => state.auth);
  const history = useHistory();

  const queryParamsRef = useRef(qs.parse(window.location.search.substring(1)));

  useEffect(() => {
    if ((!user && !fetchingUser) || downloadError) {
      const externalURL = getCCPUrl(
        queryParamsRef.current.report_id,
        queryParamsRef.current.report_ts,
        queryParamsRef.current.email
      );
      window.location.href = externalURL;
    }
  }, [user, fetchingUser, downloadError]);

  useEffect(() => {
    if (isAuthenticated && !fetchingUser) {
      dispatch(
        reportsActions.downloadReport(
          queryParamsRef.current.report_id,
          queryParamsRef.current.report_ts
        )
      );
    }
  }, [dispatch, isAuthenticated, fetchingUser]);

  useEffect(() => {
    if (downloadUrl) {
      window.location.href = downloadUrl;
      history.push(buildUrl(`/reporting/${queryParamsRef.current.report_id}`));
    }
  }, [downloadUrl]);

  return <Loading />;
};

export default ReportDownload;
